import { render, staticRenderFns } from "./lrf-tabs.vue?vue&type=template&id=5258fca2&scoped=true&"
import script from "./lrf-tabs.vue?vue&type=script&lang=js&"
export * from "./lrf-tabs.vue?vue&type=script&lang=js&"
import style0 from "./lrf-tabs.vue?vue&type=style&index=0&id=5258fca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5258fca2",
  null
  
)

export default component.exports